// /js/tiptap/Document.js
import { Node } from '@tiptap/core'

export const Document = Node.create({
  name: 'doc',
  topNode: true,

  // EXACTLY ONE chart template
  content: 'chart_template',
})
